import { createFileRoute, Outlet } from '@tanstack/react-router'
import { protectedRouteGuard } from '@/utils/routeGuards'

export const Route = createFileRoute('/infra/clusters')({
  loader: () => ({
    crumb: 'Clusters',
  }),
  beforeLoad: protectedRouteGuard,
  component: () => <Outlet />,
})
